'use strict';

import Form from '_core_ext/components/forms/Form';

export default class LoginForm extends Form {
    init() {
        super.init();
        this.event('click', '.js-login', this.login);
        this.event('change', 'input[type="checkbox"]', this.toggleCheckboxAriaAttr);
    }

    login(element, event) {
        if (!this.isChildsValid()) {
            event.preventDefault();
            return;
        }
    }

    toggleCheckboxAriaAttr(element) {
        const isChecked = element.checked;
        element.setAttribute('aria-checked', isChecked);
    }
}
module.exports = LoginForm;
